// extracted by mini-css-extract-plugin
export var cancelButton = "_o9-5";
export var content = "_o9-3";
export var createButton = "_o9-6";
export var drawerContainer = "_o9-0";
export var footer = "_o9-2";
export var header = "_o9-1";
export var orderFormColumn = "_o9-4";